import cn from "classnames";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Text } from "shared/components/Text";
import crown from "assets/icons/crown.png";

import css from "./styles.module.scss";

const checkOrientation = (image) => {
	if (image) {
		const img = new Image();
		img.src = image;
		if (img.width > img.height) {
			return "horizontal";
		}
		return "vertical";
	}
};

export const RankingEntry = ({
	place,
	teamName,
	points,
	meters,
	shouldCountPoints,
	shouldCountMeters,
	time,
	image,
	setImage,
	setIsImageVisible,
	isInTop,
	lighter,
}) => {
	const { t } = useTranslation();

	const statToRender = useMemo(() => {
		if (shouldCountPoints) {
			return (
				<Text type="pink" className={css.stat} bold secondaryFamily>
					{points}
				</Text>
			);
		} else if (shouldCountMeters) {
			return (
				<Text type="pink" className={css.stat} bold secondaryFamily>
					{meters}
				</Text>
			);
		} else {
			return (
				<Text type="lightGreen" className={css.stat} bold secondaryFamily>
					{time}
				</Text>
			);
		}
	}, [shouldCountPoints, shouldCountMeters]);

	return (
		<div
			className={cn(css.RankingEntry, {
				[css.lighter]: lighter && !isInTop,
				[css.lighterTop]: lighter && isInTop,
				[css.top]: isInTop && !lighter,
			})}
		>
			<div className={css.flexContainer}>
				<Text type="white" className={css.entryPosition} bold secondaryFamily>
					{`${place}. ${teamName.toUpperCase()}`}
				</Text>
				{image && (
					<button
						onClick={() => {
							setImage(image);
							setIsImageVisible(true);
						}}
						className={css.imageButton}
					>
						<img
							src={image}
							alt=""
							className={cn(css.image, {
								[css.horizontalImage]: checkOrientation(image) === "horizontal",
								[css.verticalImage]: checkOrientation(image) === "vertical",
							})}
						/>
					</button>
				)}
			</div>
			<div className={css.statsContainer}>
				<img
					src={crown}
					alt="crown icon"
					title="Crown icon"
					className={cn(css.crown, { [css.hidden]: !isInTop })}
				/>
				{statToRender}
			</div>
		</div>
	);
};
